module.exports = __webpack_public_path__ + "static/media/CHAP03-TITRE.1a934aa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Skew/img/CHAP03-TITRE.png
// module id = 299
// module chunks = 0